export default __webpack_public_path__ + "static/media/GAPProtection.4878e685.webp";